import { Table, Typography, Row, Col, Divider, message, Button, Space } from "antd"
import React, { useEffect, useState } from "react"

import { DownCircleOutlined, PrinterFilled, UpCircleOutlined } from "@ant-design/icons"
import { collection, doc, onSnapshot, query, updateDoc, where } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { Clock } from "../../../../media/icons/Icons"
import TapePrintingTable from "../../../../components/PaperManager/Machines/TapePrintingTable"
import { tapePrintingColumns } from "../../../../components/PaperManager/Machines/TapeTableColumns"

const { Title, Paragraph } = Typography

export default function TapePaperManager() {
  //loading data for order which are in waiting
  //list for arsoma
  // const { loading, data } = useCollection("orders", ["orderStatus", "==", 2], ["selectedProduct.machine", "==", "Arsoma"]);

  const [waitingList, setWaitingList] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRowKeysArsoma, setSelectedRowKeysArsoma] = useState([])

  //fetches the documents, then uses the sequence array to sort in correct order
  useEffect(() => {
    const ref = collection(db, "orders")
    let q = query(
      ref,
      where("orderStatus", "==", 2),
      where("selectedProduct.machine", "==", "Tape"),
      where("readyForPrinting", "==", true)
    )

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })
      setWaitingList(results)
      setTableLoading(false)
    })

    return () => unsubscribe()
  }, [])

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys)
    setSelectedRowKeys(newSelectedRowKeys)
  }

  //handles transfer from one table to another one by changing order status
  //takes two parameters, id's from selected rows and number (which indicates where to change)
  const handleBulkTransfer = async (ids, number) => {
    setTableLoading(true)
    try {
      // Create an array of Promises for each update operation
      const updatePromises = ids.map((id) => {
        const orderRef = doc(db, "orders", id)
        return updateDoc(orderRef, {
          orderStatus: number,
        })
      })

      // Wait for all update operations to complete
      await Promise.all(updatePromises)
        .then(() => {
          // Show a success message when all updates are done
          message.success("Updated!")
        })
        .then(() => {
          setTableLoading(false)
          setSelectedRowKeys([])
          setSelectedRowKeysArsoma([])
        })
    } catch (error) {
      // Handle any errors that occurred during the update operations
      console.error("Error updating documents:", error)
      message.error("An error occurred while updating documents.")
    }
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const hasSelected = selectedRowKeys.length > 0

  return (
    <>
      <div style={{ padding: 15 }}>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <Title level={3}>
              <PrinterFilled />
              <Divider type="vertical" />
              Tape Manager
            </Title>
          </Col>
          <Col span={24}>
            <Paragraph type="secondary">
              This is arsoma printer managment page. You can manage order sequence, change printer
              waiting list and do other things regarding machine managment.
            </Paragraph>
          </Col>

          {/* WAITING LIST */}
          <Col span={24}>
            <Title level={4}>
              <Clock size={16} color="red" />
              <Divider type="vertical" />
              Tape Waiting List
            </Title>
            {hasSelected ? `Selected ${selectedRowKeys.length} Orders` : ""}
            <Table
              style={{ marginTop: "15px" }}
              size="small"
              loading={tableLoading}
              bordered
              columns={tapePrintingColumns}
              dataSource={waitingList}
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              rowClassName={() => "light-red-row"}
              className="custom-table"
              pagination={{ defaultPageSize: "12", showSizeChanger: true }}
              scroll={{
                y: 500,
              }}
            />
          </Col>

          {/* BUTTONS */}
          <Col offset={11}>
            <Space>
              <Button type="primary" onClick={() => handleBulkTransfer(selectedRowKeys, 3.5)}>
                <DownCircleOutlined />
              </Button>
              <Button onClick={() => handleBulkTransfer(selectedRowKeysArsoma, 2)}>
                <UpCircleOutlined />
              </Button>
            </Space>
          </Col>
          <TapePrintingTable
            selectedRowKeysArsoma={selectedRowKeysArsoma}
            tableLoading={tableLoading}
            setSelectedRowKeysArsoma={setSelectedRowKeysArsoma}
          />
        </Row>
      </div>
    </>
  )
}
